// // src/pages/TodayAttendance.tsx
// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import {
//     Container, Row, Col, Card, CardBody, CardHeader, Button,
//     Badge, Alert, Spinner, Input, Label, FormGroup,
// } from 'reactstrap';
// import {
//     RefreshCw, Calendar, Search, User, Clock, FileText, AlertCircle,
// } from 'react-feather';
// import BreadCrumb from '../../Components/Common/BreadCrumb';
// import { toast } from 'react-toastify';
// import { apiClient } from '../../helpers/api_helper';
// import { format } from 'date-fns';
// import LocationSection from 'Components/locationcollapse';

// // ─────────────────────────── helpers ───────────────────────────
// const formatTo12Hour = (timeStr?: string | null) => {
//     if (!timeStr) return 'N/A';
//     const parts = timeStr.split(':');
//     if (parts.length < 2) return timeStr;
//     let hours = parseInt(parts[0], 10);
//     const minutes = parts[1];
//     if (isNaN(hours)) return timeStr;
//     if (hours < 6) {
//         hours = hours + 5;
//         const mins = parseInt(minutes, 10) + 30;
//         if (mins >= 60) hours = hours + 1;
//     }
//     hours = hours % 24;
//     const ampm = hours >= 12 ? 'PM' : 'AM';
//     hours = hours % 12 || 12;
//     const strHours = hours < 10 ? '0' + hours : String(hours);
//     return `${strHours}:${minutes} ${ampm}`;
// };

// const getFullImageUrl = (url: any) => {
//     if (!url) return null;
//     const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
//     if (url.startsWith('http://') || url.startsWith('https://')) {
//         const filename = url.substring(url.lastIndexOf('/') + 1);
//         return `${IMAGE_URL}/uploads/attendance/${filename}`;
//     }
//     if (url.startsWith('uploads/attendance/')) return `${IMAGE_URL}/${url}`;
//     return `${IMAGE_URL}/uploads/attendance/${url}`;
// };

// // ─────────────────────────── types ───────────────────────────
// interface Employee {
//     id: number;
//     name: string;
//     employee_code: string;
//     designation?: { id: number; title: string };
//     status: number;
//     overtime?: boolean;
// }

// interface AttendanceCell {
//     hours: number | null;
//     regular_hours: number | null;
//     overtime_hours: number | null;
//     status: string | null;
//     is_holiday: boolean;
//     is_sunday: boolean;
//     is_overtime: boolean;
//     is_manual: boolean;
//     check_in: string | null;
//     check_out: string | null;
//     check_in_photo: string | null;
//     check_out_photo: string | null;
//     check_out_notes: string | null;
//     check_in_office_name: string | null;
//     check_out_office_name: string | null;
//     check_in_office_address: string | null;
//     check_out_office_address: string | null;
//     is_different_office: boolean | null;
//     check_in_location: { latitude: number | null; longitude: number | null } | null;
//     check_out_location: { latitude: number | null; longitude: number | null } | null;
//     sessions: Array<{ in: string; out: string; duration: number; allPunches?: string[] }>;
//     holiday_name?: string;
// }

// interface EmployeeAttendance {
//     employee: Employee;
//     attendance: Record<string | number, AttendanceCell>;
//     summary: {
//         total_present: number;
//         total_half_days: number;
//         total_short_days: number;
//         total_absent: number;
//         total_hours: number;
//         total_overtime_hours: number;
//         attendance_percentage: number;
//     };
// }

// interface TodayResponse {
//     success: boolean;
//     data: {
//         date: string;
//         company_settings: any;
//         employees: EmployeeAttendance[];
//         summary: {
//             total_employees: number;
//             total_present: number;
//             total_half_days: number;
//             total_short_days: number;
//             total_absent: number;
//             total_hours: number;
//             total_overtime_hours: number;
//             attendance_percentage: number;
//         };
//     };
// }

// // ─────────────────── small presentational bits ───────────────────
// const StatusBadge: React.FC<{ cell: AttendanceCell | null }> = ({ cell }) => {
//     if (!cell) return <Badge color="secondary">No Data</Badge>;

//     if (cell.is_holiday && (!cell.hours || cell.hours === 0))
//         return <Badge color="primary">Holiday</Badge>;
//     if (cell.is_sunday && (!cell.hours || cell.hours === 0))
//         return <Badge style={{ backgroundColor: '#6f42c1' }}>Sunday</Badge>;

//     switch (cell.status) {
//         case 'full_day': return <Badge color="success">Full Day</Badge>;
//         case 'half_day': return <Badge color="info">Half Day</Badge>;
//         case 'short_day': return <Badge color="warning">Short Day</Badge>;
//         case 'no_out_time': return <Badge color="warning">No Check-Out</Badge>;
//         case 'absent': return <Badge color="danger">Absent</Badge>;
//         default: return <Badge color="secondary">{cell.status || '—'}</Badge>;
//     }
// };

// const getAttendanceKey = (
//     item: EmployeeAttendance,
// ): AttendanceCell | null => {
//     if (!item.attendance) return null;
//     const keys = Object.keys(item.attendance);
//     if (keys.length === 0) return null;
//     return item.attendance[keys[0]];
// };

// // ─────────────────────────── main page ───────────────────────────
// const TodayAttendance: React.FC = () => {
//     const [loading, setLoading] = useState(false);
//     const [data, setData] = useState<TodayResponse['data'] | null>(null);
//     const [error, setError] = useState('');
//     const [selectedDate, setSelectedDate] = useState<string>(
//         format(new Date(), 'yyyy-MM-dd'),
//     );
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(null);

//     // fetch
//     const fetchToday = useCallback(async () => {
//         setLoading(true);
//         setError('');
//         try {
//             const response = await apiClient.get('/attendance/today', {
//                 date: selectedDate,
//             });
//             if (response.success) {
//                 console.log('today',response.data)
//                 setData(response.data);
//                 // auto-select first employee
//                 if (response.data?.employees?.length > 0) {
//                     setSelectedEmployeeId((prev) =>
//                         prev && response.data.employees.some((e: any) => e.employee.id === prev)
//                             ? prev
//                             : response.data.employees[0].employee.id,
//                     );
//                 } else {
//                     setSelectedEmployeeId(null);
//                 }
//             } else {
//                 setError(response.message || 'Failed to fetch attendance');
//                 toast.error('Failed to fetch attendance');
//             }
//         } catch (err: any) {
//             console.error(err);
//             setError(err.message || 'Failed to fetch attendance');
//             toast.error('Failed to fetch attendance');
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedDate]);

//     useEffect(() => {
//         fetchToday();
//     }, [fetchToday]);

//     // client-side search
//     const filteredEmployees = useMemo(() => {
//         if (!data?.employees) return [];
//         const q = searchTerm.trim().toLowerCase();
//         if (!q) return data.employees;
//         return data.employees.filter((item) => {
//             const name = item.employee.name?.toLowerCase() || '';
//             const code = item.employee.employee_code?.toLowerCase() || '';
//             return name.includes(q) || code.includes(q);
//         });
//     }, [data, searchTerm]);

//     const selectedItem = useMemo(
//         () =>
//             filteredEmployees.find((e) => e.employee.id === selectedEmployeeId) ||
//             filteredEmployees[0] ||
//             null,
//         [filteredEmployees, selectedEmployeeId],
//     );

//     return (
//         <div className="page-content">
//             <Container fluid>
//                 <BreadCrumb title="Today's Attendance" pageTitle="Today's Attendance" />

//                 <Row>
//                     <Col lg={12}>
//                         <Card>
//                             <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
//                                 <div>
//                                     <h5 className="card-title mb-0">
//                                         <Calendar size={18} className="me-2" />
//                                         Today's Attendance
//                                     </h5>
//                                     {data && (
//                                         <small className="text-muted">
//                                             {format(new Date(selectedDate + 'T00:00:00'), 'EEEE, dd MMM yyyy')}
//                                             <Badge color="info" className="ms-2">
//                                                 {data.summary.total_employees} Employees
//                                             </Badge>
//                                         </small>
//                                     )}
//                                 </div>
//                                 <Button color="secondary" size="sm" onClick={fetchToday} disabled={loading}>
//                                     <RefreshCw size={14} className="me-1" /> Refresh
//                                 </Button>
//                             </CardHeader>

//                             <CardBody>
//                                 {/* ── filters ── */}
//                                 <div className="mb-3 p-3 border rounded bg-light">
//                                     <Row className="g-3 align-items-end">
//                                         <Col md={4}>
//                                             <FormGroup>
//                                                 <Label className="form-label-sm">Date</Label>
//                                                 <Input
//                                                     type="date"
//                                                     value={selectedDate}
//                                                     max={format(new Date(), 'yyyy-MM-dd')}
//                                                     onChange={(e) => setSelectedDate(e.target.value)}
//                                                     bsSize="sm"
//                                                 />
//                                             </FormGroup>
//                                         </Col>
//                                         <Col md={8}>
//                                             <FormGroup>
//                                                 <Label className="form-label-sm">Search</Label>
//                                                 <div className="position-relative">
//                                                     <Search
//                                                         size={14}
//                                                         className="position-absolute"
//                                                         style={{ left: 10, top: '50%', transform: 'translateY(-50%)', color: '#888' }}
//                                                     />
//                                                     <Input
//                                                         type="text"
//                                                         placeholder="Search by name or employee code…"
//                                                         value={searchTerm}
//                                                         onChange={(e) => setSearchTerm(e.target.value)}
//                                                         bsSize="sm"
//                                                         style={{ paddingLeft: 32 }}
//                                                     />
//                                                 </div>
//                                             </FormGroup>
//                                         </Col>
//                                     </Row>

//                                     {/* summary pills */}
//                                     {data && (
//                                         <div className="d-flex flex-wrap gap-2 mt-2">
//                                             <Badge color="success">Present: {data.summary.total_present}</Badge>
//                                             <Badge color="info">Half Day: {data.summary.total_half_days}</Badge>
//                                             <Badge color="warning">Short Day: {data.summary.total_short_days}</Badge>
//                                             <Badge color="danger">Absent: {data.summary.total_absent}</Badge>
//                                             <Badge color="primary">Total Hours: {data.summary.total_hours?.toFixed(1)}</Badge>
//                                             <Badge style={{ backgroundColor: '#1e7e34' }}>
//                                                 OT Hours: {data.summary.total_overtime_hours?.toFixed(1)}
//                                             </Badge>
//                                         </div>
//                                     )}
//                                 </div>

//                                 {error && (
//                                     <Alert color="danger" className="mb-3">
//                                         <AlertCircle size={16} className="me-2" /> {error}
//                                     </Alert>
//                                 )}

//                                 {loading ? (
//                                     <div className="text-center py-5">
//                                         <Spinner color="primary" className="me-2" /> Loading…
//                                     </div>
//                                 ) : !data || filteredEmployees.length === 0 ? (
//                                     <div className="text-center py-5">
//                                         <Clock size={48} className="text-muted mb-3" />
//                                         <h5>No employees found</h5>
//                                         <p className="text-muted">
//                                             {searchTerm
//                                                 ? 'No employees match your search.'
//                                                 : 'No attendance records for the selected date.'}
//                                         </p>
//                                     </div>
//                                 ) : (
//                                     <Row className="g-3">
//                                         {/* ── LEFT: employee list ── */}
//                                         <Col md={5} lg={4}>
//                                             <div
//                                                 className="border rounded"
//                                                 style={{ maxHeight: '70vh', overflowY: 'auto' }}
//                                             >
//                                                 {filteredEmployees.map((item) => {
//                                                     const cell = getAttendanceKey(item);
//                                                     const isSelected =
//                                                         selectedItem?.employee.id === item.employee.id;
//                                                     return (
//                                                         <div
//                                                             key={item.employee.id}
//                                                             onClick={() =>
//                                                                 setSelectedEmployeeId(item.employee.id)
//                                                             }
//                                                             style={{
//                                                                 cursor: 'pointer',
//                                                                 padding: '10px 12px',
//                                                                 borderBottom: '1px solid #eee',
//                                                                 backgroundColor: isSelected ? '#e7f1ff' : '#fff',
//                                                                 borderLeft: isSelected
//                                                                     ? '4px solid #0d6efd'
//                                                                     : '4px solid transparent',
//                                                             }}
//                                                         >
//                                                             <div className="d-flex justify-content-between align-items-start">
//                                                                 <div style={{ minWidth: 0 }}>
//                                                                     <div className="fw-semibold text-truncate">
//                                                                         {item.employee.name}
//                                                                     </div>
//                                                                     <small className="text-muted">
//                                                                         {item.employee.employee_code}
//                                                                         {item.employee.designation?.title
//                                                                             ? ` • ${item.employee.designation.title}`
//                                                                             : ''}
//                                                                     </small>
//                                                                 </div>
//                                                                 <div className="text-end ms-2">
//                                                                     <StatusBadge cell={cell} />
//                                                                     {cell && (
//                                                                         <div
//                                                                             className="text-muted mt-1"
//                                                                             style={{ fontSize: 11 }}
//                                                                         >
//                                                                             {cell.check_in
//                                                                                 ? formatTo12Hour(cell.check_in)
//                                                                                 : '--'}
//                                                                             {' → '}
//                                                                             {cell.check_out
//                                                                                 ? formatTo12Hour(cell.check_out)
//                                                                                 : '--'}
//                                                                         </div>
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     );
//                                                 })}
//                                             </div>
//                                         </Col>

//                                         {/* ── RIGHT: detail ── */}
//                                         <Col md={7} lg={8}>
//                                             {selectedItem ? (
//                                                 <EmployeeDetailPanel item={selectedItem} />
//                                             ) : (
//                                                 <div className="text-center text-muted py-5">
//                                                     Select an employee to view details
//                                                 </div>
//                                             )}
//                                         </Col>
//                                     </Row>
//                                 )}
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </div>
//     );
// };

// // ─────────────────────── detail panel ───────────────────────
// const EmployeeDetailPanel: React.FC<{ item: EmployeeAttendance }> = ({ item }) => {
//     const cell = getAttendanceKey(item);
//     const emp = item.employee;

//     return (
//         <div className="border rounded p-3" style={{ backgroundColor: '#fbfbfb' }}>
//             {/* header */}
//             <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
//                 <div className="d-flex align-items-center">
//                     <div
//                         className="me-3 d-flex align-items-center justify-content-center rounded-circle"
//                         style={{
//                             width: 44,
//                             height: 44,
//                             backgroundColor: '#0d6efd',
//                             color: '#fff',
//                             fontWeight: 600,
//                         }}
//                     >
//                         <User size={20} />
//                     </div>
//                     <div>
//                         <div className="fw-semibold" style={{ fontSize: '1.05rem' }}>
//                             {emp.name}
//                         </div>
//                         <small className="text-muted">
//                             {emp.employee_code}
//                             {emp.designation?.title ? ` • ${emp.designation.title}` : ''}
//                         </small>
//                     </div>
//                 </div>
//                 <StatusBadge cell={cell} />
//             </div>

//             {!cell ? (
//                 <Alert color="secondary" className="mb-0">
//                     No attendance data recorded for this employee on this date.
//                 </Alert>
//             ) : (
//                 <>
//                     {/* summary tiles */}
//                     <Row className="g-2 mb-3">
//                         <Col xs={6} md={3}>
//                             <Tile label="Total Hours" value={cell.hours != null ? `${cell.hours.toFixed(1)} h` : '—'} />
//                         </Col>
//                         <Col xs={6} md={3}>
//                             <Tile label="Regular" value={cell.regular_hours != null ? `${cell.regular_hours.toFixed(1)} h` : '—'} />
//                         </Col>
//                         <Col xs={6} md={3}>
//                             <Tile label="Overtime" value={cell.overtime_hours != null ? `${cell.overtime_hours.toFixed(1)} h` : '—'} tone="success" />
//                         </Col>
//                         <Col xs={6} md={3}>
//                             <Tile
//                                 label="Check In → Out"
//                                 value={`${cell.check_in ? formatTo12Hour(cell.check_in) : '--'} → ${cell.check_out ? formatTo12Hour(cell.check_out) : '--'
//                                     }`}
//                             />
//                         </Col>
//                     </Row>

//                     {/* check-in / check-out cards */}
//                     <Row className="g-2">
//                         <Col md={6}>
//                             <CheckCard
//                                 title="Check In"
//                                 time={cell.check_in}
//                                 photo={cell.check_in_photo}
//                                 officeName={cell.check_in_office_name}
//                                 officeAddress={cell.check_in_office_address}
//                             />
//                         </Col>
//                         <Col md={6}>
//                             <CheckCard
//                                 title="Check Out"
//                                 time={cell.check_out}
//                                 photo={cell.check_out_photo}
//                                 officeName={cell.check_out_office_name}
//                                 officeAddress={cell.check_out_office_address}
//                                 missingLabel={
//                                     cell.status === 'no_out_time' ? 'Not Checked Out' : undefined
//                                 }
//                             />
//                         </Col>
//                     </Row>

//                     {cell.is_different_office && (
//                         <div className="mt-2">
//                             <Badge color="warning">🔄 Different Office</Badge>
//                         </div>
//                     )}

//                     {/* notes */}
//                     {cell.check_out_notes && (
//                         <div
//                             className="mt-3 p-2 rounded"
//                             style={{
//                                 backgroundColor: '#fff8e1',
//                                 border: '1px solid #ffd54f',
//                             }}
//                         >
//                             <div className="d-flex align-items-center gap-2 mb-1">
//                                 <FileText size={14} />
//                                 <strong style={{ fontSize: 12 }}>Notes</strong>
//                             </div>
//                             <div style={{ whiteSpace: 'pre-wrap', fontSize: 13 }}>
//                                 {cell.check_out_notes}
//                             </div>
//                         </div>
//                     )}

//                     {/* sessions */}
//                     {cell.sessions?.length > 0 && !cell.is_manual && (
//                         <div className="mt-3">
//                             <small className="text-muted">Sessions</small>
//                             <div className="bg-light rounded p-2 mt-1">
//                                 {cell.sessions.map((s, i) => (
//                                     <div key={i} className="small">
//                                         {formatTo12Hour(s.in)} → {formatTo12Hour(s.out)} (
//                                         {s.duration.toFixed(1)} h)
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     )}

//                     {/* map */}
//                     {(cell.check_in_location?.latitude ||
//                         cell.check_out_location?.latitude) && (
//                             <div className="mt-3">
//                                 <small className="text-muted">📍 Location</small>
//                                 <div className="mt-1">
//                                     <LocationSection
//                                         checkInLocation={cell.check_in_location}
//                                         checkOutLocation={cell.check_out_location}
//                                         checkInTime={formatTo12Hour(cell.check_in)}
//                                         checkOutTime={formatTo12Hour(cell.check_out)}
//                                         showRadius={false}
//                                         radius={100}
//                                     />
//                                 </div>
//                             </div>
//                         )}
//                 </>
//             )}
//         </div>
//     );
// };

// // ─────────────────────── tiny building blocks ───────────────────────
// const Tile: React.FC<{ label: string; value: string; tone?: string }> = ({
//     label,
//     value,
//     tone,
// }) => (
//     <div className="p-2 bg-white border rounded h-100">
//         <small className="text-muted d-block">{label}</small>
//         <div className={`fw-semibold ${tone ? `text-${tone}` : ''}`}>{value}</div>
//     </div>
// );

// const CheckCard: React.FC<{
//     title: string;
//     time: string | null;
//     photo: string | null;
//     officeName: string | null;
//     officeAddress: string | null;
//     missingLabel?: string;
// }> = ({ title, time, photo, officeName, officeAddress, missingLabel }) => (
//     <div className="p-3 bg-white border rounded h-100">
//         <div className="d-flex justify-content-between align-items-center mb-2">
//             <small className="text-muted">{title}</small>
//             {missingLabel && <Badge color="warning">⚠️ {missingLabel}</Badge>}
//         </div>
//         <div className="fw-semibold mb-2">
//             {time ? formatTo12Hour(time) : '--'}
//         </div>

//         {officeName && (
//             <div className="mb-2">
//                 <Badge color="info" className="me-1">
//                     <Clock size={10} className="me-1" />
//                     Office
//                 </Badge>
//                 <span className="text-muted small">{officeName}</span>
//                 {officeAddress && (
//                     <div className="text-muted" style={{ fontSize: 10 }}>
//                         📍 {officeAddress}
//                     </div>
//                 )}
//             </div>
//         )}

//         {photo && (
//             <img
//                 src={getFullImageUrl(photo) || ''}
//                 alt={title}
//                 style={{
//                     width: 90,
//                     height: 90,
//                     objectFit: 'cover',
//                     borderRadius: 8,
//                     border: '1px solid #000',
//                 }}
//                 onError={(e) => {
//                     (e.target as HTMLImageElement).style.display = 'none';
//                 }}
//             />
//         )}
//     </div>
// );

// export default TodayAttendance;

// src/pages/TodayAttendance.tsx
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Badge,
  Alert,
  Spinner,
  Input,
  Label,
  FormGroup,
} from 'reactstrap';
import {
  RefreshCw,
  Calendar,
  Search,
  User,
  Clock,
  FileText,
  AlertCircle,
} from 'react-feather';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast } from 'react-toastify';
import { apiClient } from '../../helpers/api_helper';
import { format } from 'date-fns';
import LocationSection from 'Components/locationcollapse';

// ─────────────────────────── helpers ───────────────────────────
const formatTo12Hour = (timeStr?: string | null) => {
  if (!timeStr) return 'N/A';
  const parts = timeStr.split(':');
  if (parts.length < 2) return timeStr;
  let hours = parseInt(parts[0], 10);
  const minutes = parts[1];
  if (isNaN(hours)) return timeStr;
  if (hours < 6) {
    hours = hours + 5;
    const mins = parseInt(minutes, 10) + 30;
    if (mins >= 60) hours = hours + 1;
  }
  hours = hours % 24;
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const strHours = hours < 10 ? '0' + hours : String(hours);
  return `${strHours}:${minutes} ${ampm}`;
};

const getFullImageUrl = (url: any) => {
  if (!url) return null;
  const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    const filename = url.substring(url.lastIndexOf('/') + 1);
    return `${IMAGE_URL}/uploads/attendance/${filename}`;
  }
  if (url.startsWith('uploads/attendance/')) return `${IMAGE_URL}/${url}`;
  return `${IMAGE_URL}/uploads/attendance/${url}`;
};

// ─────────────────────────── types ───────────────────────────
interface Employee {
  id: number;
  name: string;
  employee_code: string;
  designation?: { id: number; title: string };
  status: number;
  overtime?: boolean;
}

interface LeaveCell {
  leave_request_id: number;
  leave_type_id: number | null;
  leave_type_name: string | null;
  leave_type_short: string | null;
  color_hex: string | null;
  is_paid: boolean;
  half_day_type: number | null;
  number_of_days: number;
  reason: string;
}

interface LopCell {
  id: number;
  notes: string;
  date: string;
}

interface AttendanceCell {
  hours: number | null;
  regular_hours: number | null;
  overtime_hours: number | null;
  status: string | null; // full_day | half_day | short_day | absent | no_out_time | holiday | sunday
  is_holiday: boolean;
  is_sunday: boolean;
  is_overtime: boolean;
  is_manual: boolean;
  is_half_day?: boolean;
  check_in: string | null;
  check_out: string | null;
  check_in_photo: string | null;
  check_out_photo: string | null;
  check_in_notes?: string | null;
  check_out_notes: string | null;
  check_in_office_name: string | null;
  check_out_office_name: string | null;
  check_in_office_address: string | null;
  check_out_office_address: string | null;
  is_different_office: boolean | null;
  check_in_location: { latitude: number | null; longitude: number | null } | null;
  check_out_location: { latitude: number | null; longitude: number | null } | null;
  sessions: Array<{ in: string; out: string; duration: number; allPunches?: string[] }>;
  holiday_name?: string;
  leave?: LeaveCell | null;
  lop?: LopCell | null;
}

interface EmployeeAttendance {
  employee: Employee;
  attendance: Record<string | number, AttendanceCell>;
  summary: {
    total_present: number;
    total_half_days: number;
    total_short_days: number;
    total_absent: number;
    total_hours: number;
    total_overtime_hours: number;
    attendance_percentage: number;
  };
}

interface TodayResponse {
  success: boolean;
  data: {
    date: string;
    company_settings: any;
    employees: EmployeeAttendance[];
    summary: {
      total_employees: number;
      total_present: number;
      total_half_days: number;
      total_short_days: number;
      total_absent: number;
      total_hours: number;
      total_overtime_hours: number;
      attendance_percentage: number;
    };
  };
}

// ─────────────────────── status resolution ───────────────────────
// Priority order (mirrors the main Attendance page):
//   1. LOP
//   2. Holiday
//   3. Leave
//   4. Sunday
//   5. No Out Time
//   6. Manual
//   7. Overtime
//   8. Full day
//   9. Half day
//  10. Short day
//  11. Absent / No data

type ResolvedStatus =
  | { kind: 'lop'; label: 'LOP'; color: 'danger'; bg: string; border: string; note?: string }
  | { kind: 'holiday-worked'; label: string; color: 'primary'; note?: string }
  | { kind: 'holiday'; label: 'Holiday'; color: 'primary'; note?: string }
  | { kind: 'leave'; label: string; color: 'info'; note?: string; leaveColor?: string | null }
  | { kind: 'sunday-worked'; label: string; color: 'light'; bg: string }
  | { kind: 'sunday'; label: 'Sunday'; color: 'light'; bg: string }
  | { kind: 'no_out'; label: 'No Check-Out'; color: 'warning'; note?: string }
  | { kind: 'manual'; label: string; color: 'warning' }
  | { kind: 'ot'; label: string; bg: string }
  | { kind: 'full_day'; label: 'Full Day'; color: 'success' }
  | { kind: 'half_day'; label: 'Half Day'; color: 'info' }
  | { kind: 'short_day'; label: 'Short Day'; color: 'warning' }
  | { kind: 'absent'; label: 'Absent'; color: 'danger' }
  | { kind: 'none'; label: 'No Data'; color: 'secondary' };

function resolveStatus(cell: AttendanceCell | null): ResolvedStatus {
  if (!cell) return { kind: 'none', label: 'No Data', color: 'secondary' };

  // 1. LOP takes priority over everything
  if (cell.lop) {
    return {
      kind: 'lop',
      label: 'LOP',
      color: 'danger',
      bg: '#8b0000',
      border: '#ffd700',
      note: cell.lop.notes,
    };
  }

  const hasHours = cell.hours != null && cell.hours > 0;
  const worked = hasHours || !!cell.check_in;

  // 2. Holiday
  if (cell.is_holiday) {
    if (worked) {
      return {
        kind: 'holiday-worked',
        label: 'Holiday (Worked)',
        color: 'primary',
        note: cell.holiday_name,
      };
    }
    return { kind: 'holiday', label: 'Holiday', color: 'primary', note: cell.holiday_name };
  }

  // 3. Leave
  if (cell.leave) {
    return {
      kind: 'leave',
      label: cell.leave.leave_type_name || 'Leave',
      color: 'info',
      note: `${cell.leave.is_paid ? 'Paid' : 'Unpaid'} • ${cell.leave.number_of_days} day${Number(cell.leave.number_of_days) === 1 ? '' : 's'}`,
      leaveColor: cell.leave.color_hex,
    };
  }

  // 4. Sunday
  if (cell.is_sunday) {
    if (worked) {
      return { kind: 'sunday-worked', label: 'Sunday (Worked)', color: 'light', bg: '#6f42c1' };
    }
    return { kind: 'sunday', label: 'Sunday', color: 'light', bg: '#6f42c1' };
  }

  // 5. No out time (checked in, no check-out)
  if (cell.status === 'no_out_time' && cell.check_in) {
    return {
      kind: 'no_out',
      label: 'No Check-Out',
      color: 'warning',
      note: `In at ${formatTo12Hour(cell.check_in)}`,
    };
  }

  // 6. Manual entry
  if (cell.is_manual) {
    return {
      kind: 'manual',
      label: `Manual${hasHours ? ` • ${cell.hours?.toFixed(1)} h` : ''}`,
      color: 'warning',
    };
  }

  // 7. Overtime (regular day with OT hours)
  if (cell.is_overtime && cell.overtime_hours && cell.overtime_hours > 0) {
    return {
      kind: 'ot',
      label: `OT • ${cell.overtime_hours.toFixed(1)} h`,
      bg: '#1e7e34',
    };
  }

  // 8–10. Standard statuses
  switch (cell.status) {
    case 'full_day':
      return { kind: 'full_day', label: 'Full Day', color: 'success' };
    case 'half_day':
      return { kind: 'half_day', label: 'Half Day', color: 'info' };
    case 'short_day':
      return { kind: 'short_day', label: 'Short Day', color: 'warning' };
    case 'absent':
      return { kind: 'absent', label: 'Absent', color: 'danger' };
  }

  // Fallback
  return { kind: 'none', label: 'No Data', color: 'secondary' };
}

// ─────────────────── small presentational bits ───────────────────
const StatusBadge: React.FC<{ cell: AttendanceCell | null; size?: 'sm' | 'md' }> = ({
  cell,
  size = 'md',
}) => {
  const status = resolveStatus(cell);
  const fontSize = size === 'sm' ? 11 : 13;

  // Custom styles for the ones that don't map to a Bootstrap color
  const customStyle: React.CSSProperties = { fontSize };

  if (status.kind === 'lop') {
    Object.assign(customStyle, {
      backgroundColor: status.bg,
      color: '#fff',
      border: `1.5px solid ${status.border}`,
      fontWeight: 800,
      letterSpacing: '0.04em',
    });
    return (
      <Badge pill style={customStyle} title={status.note || 'Loss of Pay'}>
        LOP
      </Badge>
    );
  }

  if (status.kind === 'sunday' || status.kind === 'sunday-worked') {
    Object.assign(customStyle, {
      backgroundColor: status.bg,
      color: '#fff',
      fontWeight: 600,
    });
    return (
      <Badge pill style={customStyle}>
        {status.label}
      </Badge>
    );
  }

  if (status.kind === 'leave') {
    Object.assign(customStyle, {
      backgroundColor: status.leaveColor || '#0dcaf0',
      color: '#fff',
      fontWeight: 600,
    });
    return (
      <Badge pill style={customStyle} title={status.note}>
        {status.label}
      </Badge>
    );
  }

  if (status.kind === 'ot') {
    Object.assign(customStyle, {
      backgroundColor: status.bg,
      color: '#fff',
      fontWeight: 600,
    });
    return <Badge pill style={customStyle}>{status.label}</Badge>;
  }

  // Default: reactstrap colors
  return (
    <Badge pill color={status.color} style={customStyle} >
      {status.label}
    </Badge>
  );
};

/**
 * Small colored dot used on the left of each row in the employee list —
 * helps scan the list quickly.
 */
const StatusDot: React.FC<{ cell: AttendanceCell | null }> = ({ cell }) => {
  const status = resolveStatus(cell);
  let color = '#adb5bd'; // default gray
  switch (status.kind) {
    case 'lop':
      color = '#8b0000';
      break;
    case 'holiday':
    case 'holiday-worked':
      color = '#0d6efd';
      break;
    case 'leave':
      color = status.leaveColor || '#0dcaf0';
      break;
    case 'sunday':
    case 'sunday-worked':
      color = '#6f42c1';
      break;
    case 'no_out':
      color = '#ffc107';
      break;
    case 'manual':
      color = '#fd7e14';
      break;
    case 'ot':
      color = '#1e7e34';
      break;
    case 'full_day':
      color = '#28a745';
      break;
    case 'half_day':
      color = '#17a2b8';
      break;
    case 'short_day':
      color = '#fd7e14';
      break;
    case 'absent':
      color = '#dc3545';
      break;
    default:
      color = '#adb5bd';
  }
  return (
    <span
      style={{
        display: 'inline-block',
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: 8,
        flexShrink: 0,
      }}
    />
  );
};

const getAttendanceKey = (item: EmployeeAttendance): AttendanceCell | null => {
  if (!item.attendance) return null;
  const keys = Object.keys(item.attendance);
  if (keys.length === 0) return null;
  return item.attendance[keys[0]];
};

// ─────────────────────────── main page ───────────────────────────
const TodayAttendance: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<TodayResponse['data'] | null>(null);
  const [error, setError] = useState('');
  const [selectedDate, setSelectedDate] = useState<string>(
    format(new Date(), 'yyyy-MM-dd'),
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(null);

  const fetchToday = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const response = await apiClient.get('/attendance/today', {
        date: selectedDate,
      });
      console.log('today',response.data)
      if (response.success) {
        setData(response.data);
        if (response.data?.employees?.length > 0) {
          setSelectedEmployeeId((prev) =>
            prev && response.data.employees.some((e: any) => e.employee.id === prev)
              ? prev
              : response.data.employees[0].employee.id,
          );
        } else {
          setSelectedEmployeeId(null);
        }
      } else {
        setError(response.message || 'Failed to fetch attendance');
        toast.error('Failed to fetch attendance');
      }
    } catch (err: any) {
      console.error(err);
      setError(err.message || 'Failed to fetch attendance');
      toast.error('Failed to fetch attendance');
    } finally {
      setLoading(false);
    }
  }, [selectedDate]);

  useEffect(() => {
    fetchToday();
  }, [fetchToday]);

  const filteredEmployees = useMemo(() => {
    if (!data?.employees) return [];
    const q = searchTerm.trim().toLowerCase();
    if (!q) return data.employees;
    return data.employees.filter((item) => {
      const name = item.employee.name?.toLowerCase() || '';
      const code = item.employee.employee_code?.toLowerCase() || '';
      return name.includes(q) || code.includes(q);
    });
  }, [data, searchTerm]);

  const selectedItem = useMemo(
    () =>
      filteredEmployees.find((e) => e.employee.id === selectedEmployeeId) ||
      filteredEmployees[0] ||
      null,
    [filteredEmployees, selectedEmployeeId],
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Today's Attendance" pageTitle="Today's Attendance" />

        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div>
                  <h5 className="card-title mb-0">
                    <Calendar size={18} className="me-2" />
                    Today's Attendance
                  </h5>
                  {data && (
                    <small className="text-muted">
                      {format(new Date(selectedDate + 'T00:00:00'), 'EEEE, dd MMM yyyy')}
                      <Badge color="info" className="ms-2">
                        {data.summary.total_employees} Employees
                      </Badge>
                    </small>
                  )}
                </div>
                <Button color="secondary" size="sm" onClick={fetchToday} disabled={loading}>
                  <RefreshCw size={14} className="me-1" /> Refresh
                </Button>
              </CardHeader>

              <CardBody>
                {/* ── filters ── */}
                <div className="mb-3 p-3 border rounded bg-light">
                  <Row className="g-3 align-items-end">
                    <Col md={4}>
                      <FormGroup>
                        <Label className="form-label-sm">Date</Label>
                        <Input
                          type="date"
                          value={selectedDate}
                          max={format(new Date(), 'yyyy-MM-dd')}
                          onChange={(e) => setSelectedDate(e.target.value)}
                          bsSize="sm"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={8}>
                      <FormGroup>
                        <Label className="form-label-sm">Search</Label>
                        <div className="position-relative">
                          <Search
                            size={14}
                            className="position-absolute"
                            style={{
                              left: 10,
                              top: '50%',
                              transform: 'translateY(-50%)',
                              color: '#888',
                            }}
                          />
                          <Input
                            type="text"
                            placeholder="Search by name or employee code…"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            bsSize="sm"
                            style={{ paddingLeft: 32 }}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* summary pills */}
                  {data && (
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      <Badge color="success">Present: {data.summary.total_present}</Badge>
                      <Badge color="info">Half Day: {data.summary.total_half_days}</Badge>
                      <Badge color="warning">Short Day: {data.summary.total_short_days}</Badge>
                      <Badge color="danger">Absent: {data.summary.total_absent}</Badge>
                      <Badge color="primary">
                        Total Hours: {data.summary.total_hours?.toFixed(1)}
                      </Badge>
                      <Badge style={{ backgroundColor: '#1e7e34' }}>
                        OT Hours: {data.summary.total_overtime_hours?.toFixed(1)}
                      </Badge>
                    </div>
                  )}
                </div>

                {error && (
                  <Alert color="danger" className="mb-3">
                    <AlertCircle size={16} className="me-2" /> {error}
                  </Alert>
                )}

                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" className="me-2" /> Loading…
                  </div>
                ) : !data || filteredEmployees.length === 0 ? (
                  <div className="text-center py-5">
                    <Clock size={48} className="text-muted mb-3" />
                    <h5>No employees found</h5>
                    <p className="text-muted">
                      {searchTerm
                        ? 'No employees match your search.'
                        : 'No attendance records for the selected date.'}
                    </p>
                  </div>
                ) : (
                  <Row className="g-3">
                    {/* ── LEFT: employee list ── */}
                    <Col md={5} lg={4}>
                      <div
                        className="border rounded"
                        style={{ maxHeight: '70vh', overflowY: 'auto' }}
                      >
                        {filteredEmployees.map((item) => {
                          const cell = getAttendanceKey(item);
                          const isSelected =
                            selectedItem?.employee.id === item.employee.id;
                          return (
                            <div
                              key={item.employee.id}
                              onClick={() => setSelectedEmployeeId(item.employee.id)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px 12px',
                                borderBottom: '1px solid #eee',
                                backgroundColor: isSelected ? '#e7f1ff' : '#fff',
                                borderLeft: isSelected
                                  ? '4px solid #0d6efd'
                                  : '4px solid transparent',
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-start">
                                <div
                                  className="d-flex align-items-start"
                                  style={{ minWidth: 0 }}
                                >
                                  <StatusDot cell={cell} />
                                  <div style={{ minWidth: 0 }}>
                                    <div className="fw-semibold text-truncate">
                                      {item.employee.name}
                                    </div>
                                    <small className="text-muted">
                                      {item.employee.employee_code}
                                      {item.employee.designation?.title
                                        ? ` • ${item.employee.designation.title}`
                                        : ''}
                                    </small>
                                  </div>
                                </div>
                                <div className="text-end ms-2">
                                  <StatusBadge cell={cell} size="sm" />
                                  {cell && (
                                    <div
                                      className="text-muted mt-1"
                                      style={{ fontSize: 11 }}
                                    >
                                      {cell.check_in ? formatTo12Hour(cell.check_in) : '--'}
                                      {' → '}
                                      {cell.check_out ? formatTo12Hour(cell.check_out) : '--'}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Col>

                    {/* ── RIGHT: detail ── */}
                    <Col md={7} lg={8}>
                      {selectedItem ? (
                        <EmployeeDetailPanel item={selectedItem} />
                      ) : (
                        <div className="text-center text-muted py-5">
                          Select an employee to view details
                        </div>
                      )}
                    </Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

// ─────────────────────── detail panel ───────────────────────
const EmployeeDetailPanel: React.FC<{ item: EmployeeAttendance }> = ({ item }) => {
  const cell = getAttendanceKey(item);
  const emp = item.employee;
  const status = resolveStatus(cell);

  return (
    <div className="border rounded p-3" style={{ backgroundColor: '#fbfbfb' }}>
      {/* header */}
      <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
        <div className="d-flex align-items-center">
          <div
            className="me-3 d-flex align-items-center justify-content-center rounded-circle"
            style={{
              width: 44,
              height: 44,
              backgroundColor: '#0d6efd',
              color: '#fff',
              fontWeight: 600,
            }}
          >
            <User size={20} />
          </div>
          <div>
            <div className="fw-semibold" style={{ fontSize: '1.05rem' }}>
              {emp.name}
            </div>
            <small className="text-muted">
              {emp.employee_code}
              {emp.designation?.title ? ` • ${emp.designation.title}` : ''}
            </small>
          </div>
        </div>
        <StatusBadge cell={cell} />
      </div>

      {/* LOP banner */}
      {cell?.lop && (
        <div
          className="mb-3 p-3 rounded d-flex align-items-start gap-2"
          style={{
            background: 'linear-gradient(135deg, #fff5f5, #ffe5e5)',
            border: '2px solid #8b0000',
          }}
        >
          <span style={{ fontSize: '22px', lineHeight: 1 }}>🚫</span>
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-1">
              <span
                style={{
                  backgroundColor: '#8b0000',
                  color: '#fff',
                  fontSize: '0.65rem',
                  fontWeight: 800,
                  padding: '2px 8px',
                  borderRadius: 4,
                  border: '1.5px solid #ffd700',
                  letterSpacing: '0.05em',
                }}
              >
                LOSS OF PAY
              </span>
              <small className="text-muted">Salary for this day will be deducted</small>
            </div>
            <div className="small" style={{ color: '#4a0000', whiteSpace: 'pre-wrap' }}>
              <strong>Reason:</strong> {cell.lop.notes}
            </div>
          </div>
        </div>
      )}

      {/* Leave banner */}
      {cell?.leave && (
        <div
          className="mb-3 p-3 rounded"
          style={{
            background: '#f0f9ff',
            border: `2px solid ${cell.leave.color_hex || '#0dcaf0'}`,
          }}
        >
          <div className="d-flex align-items-center gap-2 mb-1">
            <span
              style={{
                backgroundColor: cell.leave.color_hex || '#0dcaf0',
                color: '#fff',
                fontSize: '0.7rem',
                fontWeight: 700,
                padding: '3px 10px',
                borderRadius: 4,
              }}
            >
              {cell.leave.leave_type_short || cell.leave.leave_type_name || 'LEAVE'}
            </span>
            <span className="fw-semibold">{cell.leave.leave_type_name}</span>
            <Badge color={cell.leave.is_paid ? 'primary' : 'secondary'}>
              {cell.leave.is_paid ? 'Paid' : 'Unpaid'}
            </Badge>
            <small className="text-muted">
              {Number(cell.leave.number_of_days)} day
              {Number(cell.leave.number_of_days) === 1 ? '' : 's'}
              {cell.leave.half_day_type != null && ' (Half Day)'}
            </small>
          </div>
          <div style={{ whiteSpace: 'pre-wrap', fontSize: 13 }}>
            <strong>Reason:</strong> {cell.leave.reason}
          </div>
        </div>
      )}

      {!cell ? (
        <Alert color="secondary" className="mb-0">
          No attendance data recorded for this employee on this date.
        </Alert>
      ) : (
        <>
          {/* summary tiles */}
          <Row className="g-2 mb-3">
            <Col xs={6} md={3}>
              <Tile
                label="Total Hours"
                value={cell.hours != null ? `${cell.hours.toFixed(1)} h` : '—'}
              />
            </Col>
            <Col xs={6} md={3}>
              <Tile
                label="Regular"
                value={cell.regular_hours != null ? `${cell.regular_hours.toFixed(1)} h` : '—'}
              />
            </Col>
            <Col xs={6} md={3}>
              <Tile
                label="Overtime"
                value={
                  cell.overtime_hours != null ? `${cell.overtime_hours.toFixed(1)} h` : '—'
                }
                tone="success"
              />
            </Col>
            <Col xs={6} md={3}>
              <Tile
                label="Check In → Out"
                value={`${cell.check_in ? formatTo12Hour(cell.check_in) : '--'} → ${
                  cell.check_out ? formatTo12Hour(cell.check_out) : '--'
                }`}
              />
            </Col>
          </Row>

          {/* if the day has no punches at all and no leave/LOP — show placeholder */}
          {!cell.check_in && !cell.check_out && !cell.leave && !cell.lop && (
            <Alert color="secondary" className="mb-3">
              {cell.is_holiday
                ? 'Holiday — no punches recorded.'
                : cell.is_sunday
                ? 'Sunday — no punches recorded.'
                : 'Absent — no punches recorded.'}
            </Alert>
          )}

          {/* check-in / check-out cards */}
          {(cell.check_in || cell.check_out) && (
            <Row className="g-2">
              <Col md={6}>
                <CheckCard
                  title="Check In"
                  time={cell.check_in}
                  photo={cell.check_in_photo}
                  officeName={cell.check_in_office_name}
                  officeAddress={cell.check_in_office_address}
                />
              </Col>
              <Col md={6}>
                <CheckCard
                  title="Check Out"
                  time={cell.check_out}
                  photo={cell.check_out_photo}
                  officeName={cell.check_out_office_name}
                  officeAddress={cell.check_out_office_address}
                  missingLabel={
                    cell.status === 'no_out_time' ? 'Not Checked Out' : undefined
                  }
                />
              </Col>
            </Row>
          )}

          {cell.is_different_office && (
            <div className="mt-2">
              <Badge color="warning">🔄 Different Office</Badge>
            </div>
          )}

          {/* notes */}
          {cell.check_out_notes && (
            <div
              className="mt-3 p-2 rounded"
              style={{
                backgroundColor: '#fff8e1',
                border: '1px solid #ffd54f',
              }}
            >
              <div className="d-flex align-items-center gap-2 mb-1">
                <FileText size={14} />
                <strong style={{ fontSize: 12 }}>Notes</strong>
              </div>
              <div style={{ whiteSpace: 'pre-wrap', fontSize: 13 }}>
                {cell.check_out_notes}
              </div>
            </div>
          )}

          {/* sessions */}
          {cell.sessions?.length > 0 && !cell.is_manual && (
            <div className="mt-3">
              <small className="text-muted">Sessions</small>
              <div className="bg-light rounded p-2 mt-1">
                {cell.sessions.map((s, i) => (
                  <div key={i} className="small">
                    {formatTo12Hour(s.in)} → {formatTo12Hour(s.out)} ({s.duration.toFixed(1)} h)
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* map */}
          {(cell.check_in_location?.latitude || cell.check_out_location?.latitude) && (
            <div className="mt-3">
              <small className="text-muted">📍 Location</small>
              <div className="mt-1">
                <LocationSection
                  checkInLocation={cell.check_in_location}
                  checkOutLocation={cell.check_out_location}
                  checkInTime={formatTo12Hour(cell.check_in)}
                  checkOutTime={formatTo12Hour(cell.check_out)}
                  showRadius={false}
                  radius={100}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

// ─────────────────────── tiny building blocks ───────────────────────
const Tile: React.FC<{ label: string; value: string; tone?: string }> = ({
  label,
  value,
  tone,
}) => (
  <div className="p-2 bg-white border rounded h-100">
    <small className="text-muted d-block">{label}</small>
    <div className={`fw-semibold ${tone ? `text-${tone}` : ''}`}>{value}</div>
  </div>
);

const CheckCard: React.FC<{
  title: string;
  time: string | null;
  photo: string | null;
  officeName: string | null;
  officeAddress: string | null;
  missingLabel?: string;
}> = ({ title, time, photo, officeName, officeAddress, missingLabel }) => (
  <div className="p-3 bg-white border rounded h-100">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <small className="text-muted">{title}</small>
      {missingLabel && <Badge color="warning">⚠️ {missingLabel}</Badge>}
    </div>
    <div className="fw-semibold mb-2">{time ? formatTo12Hour(time) : '--'}</div>

    {officeName && (
      <div className="mb-2">
        <Badge color="info" className="me-1">
          <Clock size={10} className="me-1" />
          Office
        </Badge>
        <span className="text-muted small">{officeName}</span>
        {officeAddress && (
          <div className="text-muted" style={{ fontSize: 10 }}>
            📍 {officeAddress}
          </div>
        )}
      </div>
    )}

    {photo && (
      <img
        src={getFullImageUrl(photo) || ''}
        alt={title}
        style={{
          width: 90,
          height: 90,
          objectFit: 'cover',
          borderRadius: 8,
          border: '1px solid #000',
        }}
        onError={(e) => {
          (e.target as HTMLImageElement).style.display = 'none';
        }}
      />
    )}
  </div>
);

export default TodayAttendance;